import { Icon } from "@introist/react-foundation/v2";
import styled from "styled-components";

const MetricContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xSmall);
  padding: var(--spacing-small);
  background: var(--palette-background-surface);
  border-radius: 8px;
  border: 1px solid var(--palette-border-default);
`;

const MetricHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const MetricLabel = styled.div`
  font-size: 0.75rem;
  color: var(--palette-text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 500;
`;

const MetricValue = styled.div<{ $status?: "good" | "warning" | "danger" }>`
  font-size: 1.25rem;
  font-weight: 700;
  color: ${({ $status }) => {
    switch ($status) {
      case "danger":
        return "var(--palette-danger-default)";
      case "warning":
        return "var(--palette-warning-default)";
      case "good":
        return "var(--palette-success-default)";
      default:
        return "var(--palette-text-primary)";
    }
  }};
`;

const ProgressBar = styled.div`
  width: 100%;
  height: 6px;
  background: var(--palette-background-default);
  border-radius: 3px;
  overflow: hidden;
  margin-top: var(--spacing-xSmall);
`;

const ProgressFill = styled.div<{ $percentage: number; $status?: "good" | "warning" | "danger" }>`
  height: 100%;
  width: ${({ $percentage }) => Math.min(100, Math.max(0, $percentage))}%;
  background: ${({ $status }) => {
    switch ($status) {
      case "danger":
        return "var(--palette-danger-default)";
      case "warning":
        return "var(--palette-warning-default)";
      case "good":
        return "var(--palette-success-default)";
      default:
        return "var(--palette-primary-default)";
    }
  }};
  transition: width 0.3s ease;
`;

const MetricSubtext = styled.div`
  font-size: 0.75rem;
  color: var(--palette-text-secondary);
  margin-top: 2px;
`;

type EmployeeMetricCardProps = {
  label: string;
  value: string | number;
  icon?: string;
  status?: "good" | "warning" | "danger";
  showProgress?: boolean;
  progressPercentage?: number;
  subtext?: string;
};

export const EmployeeMetricCard = ({
  label,
  value,
  icon,
  status,
  showProgress = false,
  progressPercentage = 0,
  subtext
}: EmployeeMetricCardProps) => {
  return (
    <MetricContainer>
      <MetricHeader>
        <MetricLabel>{label}</MetricLabel>
        {icon && <Icon name={icon as any} style={{ fontSize: 16, color: "var(--palette-text-secondary)" }} />}
      </MetricHeader>
      <MetricValue $status={status}>{value}</MetricValue>
      {showProgress && (
        <ProgressBar>
          <ProgressFill $percentage={progressPercentage} $status={status} />
        </ProgressBar>
      )}
      {subtext && <MetricSubtext>{subtext}</MetricSubtext>}
    </MetricContainer>
  );
};
